import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
// Author      : Olli Powroznik, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 161511 $
// Purpose     : slider widget implementation
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Icon, Button, Transition } from 'semantic-ui-react';
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { get, size, mapItems, flatten, delay } from 'ldash';
import { useSelector, useActions, useState, useImagePreload, useInterval } from 'uix/hooks';
import log from 'uix/logging';
// ---Local imports
import HStyles from './heroSlider.css';
import { wcUrl } from './utils';
// ---Globals
let DATA = [
    {
        header: 'Die Kanone',
        pageId: 135648,
        width: 304,
        height: 447,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '103%'
    },
    {
        header: 'Die Karte',
        pageId: 110795,
        width: 304,
        height: 193,
        description: 'Mit der aktuellen Version 1906ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard derr Text Encoding Initiative (TEI) zu erschließen. Sie finden hier ausgewählte Beispiele, die die Möglichkeiten der Erschließung verdeutlichen. Machen Sie Ihre Bestände sichtbar!',
        category: 'Fundstücke',
        crop: '106%'
    },
    {
        header: 'Die Karte',
        pageId: 432785,
        width: 300,
        height: 475,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '116%'
    },
    {
        header: 'Die Karte',
        pageId: 440859,
        width: 300,
        height: 475,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '110%'
    },
    {
        header: 'Die Karte',
        pageId: 379996,
        width: 300,
        height: 475,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '116%'
    },
    {
        header: 'Die Karte',
        pageId: 116008,
        width: 300,
        height: 428,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '116%'
    }
];
let SliderBody = ({ pageId, src, category, width, height, header, description, crop })=>{
    let apiurl = useSelector(Sel.apiurl);
    let go = useActions(Actions.go);
    let maxHeight = 300;
    let maxWidth = 450;
    if (width > height) {
        height = Math.round(height * maxWidth / width);
        width = maxWidth;
    } else {
        width = Math.round(width * maxHeight / height);
        height = maxHeight;
    }
    let url = src ? apiurl.href(src) : wcUrl(apiurl, 1000, pageId);
    let cssImgUrl = `url(${url})`;
    const sliderBackground = {
        backgroundImage: cssImgUrl
    };
    const pageBackground = {
        backgroundImage: cssImgUrl,
        width: width,
        height: height,
        backgroundSize: crop
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: HStyles.overlayContainer,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: HStyles.contentContainer,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            onClick: ()=>go({
                                    tabname: 'viewer',
                                    id: pageId
                                }),
                            className: HStyles.page,
                            style: pageBackground
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: HStyles.textArea,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: HStyles.category,
                                    children: category
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: HStyles.title,
                                    children: header
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: HStyles.description,
                                    children: description
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: ()=>goToPage(),
                                    content: "mehr erfahren"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: HStyles.imgBackground,
                style: sliderBackground
            })
        ]
    }, pageId);
};
export const HeaderSliderProto = ({ data = DATA, auto = true })=>{
    /* slider component
  :param auto: switch to next slide after some duration
  :type auto: false/true or custom integer for delay in ms
  */ let apiurl = useSelector(Sel.apiurl);
    let [index, setIndex] = useState(0);
    let [hover, setHover] = useState(false);
    let currentIndex = Math.abs(index % data.length);
    let prevIndex = Math.abs((index + data.length - 1) % data.length);
    let nextIndex = Math.abs((index + 1) % data.length);
    // reset delay on currentIndex change or hover state change
    // delay of null stops timer
    let delay = auto ? auto : null;
    if (delay === true) {
        delay = 10000; // 10 sec default
    }
    useInterval(()=>setIndex(nextIndex), delay, currentIndex, hover);
    let pagePreload = [];
    if (data.length > 0) {
        if (!data[currentIndex].src) {
            pagePreload = [
                wcUrl(apiurl, 1000, data[prevIndex].pageId),
                wcUrl(apiurl, 304, data[prevIndex].pageId),
                wcUrl(apiurl, 1000, data[nextIndex].pageId),
                wcUrl(apiurl, 304, data[nextIndex].pageId)
            ];
        } else {
            // direct src values given
            pagePreload = [
                apiurl.href(data[prevIndex].src),
                apiurl.href(data[nextIndex].src)
            ];
        }
    }
    const loaded = useImagePreload(pagePreload);
    const nextSlide = ()=>setIndex(nextIndex);
    const prevSlide = ()=>setIndex(prevIndex);
    const jumpToSlide = (pageIndex)=>setIndex(pageIndex);
    const indicator = data.map((e, pageIndex)=>{
        if (pageIndex == currentIndex) {
            return /*#__PURE__*/ _jsx(Icon, {
                color: "black",
                onClick: ()=>jumpToSlide(pageIndex),
                link: true,
                id: HStyles.activeIndicator,
                name: "circle outline"
            }, pageIndex);
        }
        {
            return /*#__PURE__*/ _jsx(Icon, {
                color: "black",
                onClick: ()=>jumpToSlide(pageIndex),
                size: "small",
                link: true,
                name: "circle"
            }, pageIndex);
        }
    });
    // ///Swipe Funktionalität from react-touch
    // <Swipeable onSwipeLeft={nextSlide} onSwipeRight={prevSlide}>
    // </Swipeable>
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            onMouseLeave: ()=>setHover(false),
            onMouseEnter: ()=>setHover(true),
            className: HStyles.sliderContainer,
            children: [
                /*#__PURE__*/ _jsx(Transition, {
                    visible: hover,
                    animation: "fade left",
                    duration: 500,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        id: HStyles.prev,
                        size: "big",
                        color: "black",
                        name: "angle left",
                        link: true,
                        onClick: prevSlide
                    })
                }),
                /*#__PURE__*/ _jsx(Transition, {
                    visible: hover,
                    animation: "fade right",
                    duration: 500,
                    children: /*#__PURE__*/ _jsx(Icon, {
                        id: HStyles.next,
                        size: "big",
                        color: "black",
                        name: "angle right",
                        link: true,
                        onClick: nextSlide
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: HStyles.indicatorContainer,
                    children: indicator
                }),
                data.length > 0 && /*#__PURE__*/ _jsx(SliderBody, {
                    ...data[currentIndex]
                })
            ]
        })
    });
};
